import { Directive, ElementRef, HostListener, OnInit } from '@angular/core';

@Directive({
  // tslint:disable-next-line:directive-selector
  selector: '[posInputUpdate]'
}) export class PosInputUpdateDirective implements OnInit {
constructor(private el: ElementRef) {
}
ngOnInit() {
    console.log(this.el.nativeElement);
}
  @HostListener('change', ['$event']) onChange(event: any) {
    console.log(event);
    if (event.target !== event.currentTarget && this.el.nativeElement.classList.contains('open')) {
      // console.log(event)
    }
  }
  @HostListener('click', ['$event']) onClick(event: any) {
    console.log(event);
    if (event.target !== event.currentTarget && this.el.nativeElement.classList.contains('open')) {
      // console.log(event)
    }
  }
}
